import { render, staticRenderFns } from "./rejectionComment.vue?vue&type=template&id=52c6c7e7"
import script from "./rejectionComment.vue?vue&type=script&lang=js"
export * from "./rejectionComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports